<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Inventario de armas</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="2">
                  <v-select
                    label="Marca"
                    rounded
                    filled
                    dense
                    v-model="selectedMarca"
                    @change="fetchModeloArmas($event)"
                    :items="marcas"
                    item-value="id"
                    item-text="title"
                    item-color="secondary"
                    color="secondary"
                    background-color="primary"
                  ></v-select>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="2">
                  <registrar-movimiento-arma-dialog-component></registrar-movimiento-arma-dialog-component>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="buscaArma"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="primary"
                    color="secondary"
                    label="Buscar arma"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    class="primary ui-module-table"
                    :headers="headers"
                    :items="modeloArmas"
                    :search="buscaArma"
                    :loading="loading"
                    calculate-widths
                  >
                    <template v-slot:[`item.opciones`]="{ item }">
                      <v-btn
                        rounded
                        small
                        color="secondary"
                        class="ui-module-btn-solid ui-module-btn"
                        @click="openEstatusArmaDialog(item)"
                        >Ver movimientos</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <historial-movimientos-arma-dialog-component
      :active="historialMovimientosArmaDialog"
      :id-modelo="selectedModelo"
      v-on:close="historialMovimientosArmaDialog = false"
    ></historial-movimientos-arma-dialog-component>
  </v-container>
</template>

<style scoped>
/* Campos de entrada y selección */
::v-deep .v-text-field,
::v-deep .v-select {
  border-radius: 12px;
}

::v-deep .v-text-field__slot input,
::v-deep .v-select__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-input__control {
  background: rgba(18, 18, 18, 0.4) !important;
  border-radius: 12px;
  border: 1px solid rgba(108, 92, 231, 0.2);
  transition: all 0.3s ease;
}

::v-deep .v-input__control:hover {
  border-color: rgba(108, 92, 231, 0.4);
}

::v-deep .v-input--is-focused .v-input__control {
  border-color: #6c5ce7 !important;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

::v-deep .v-label {
  color: #b0b0b0 !important;
}

::v-deep .v-input--is-focused .v-label {
  color: #6c5ce7 !important;
}

/* ==================== ICONOS ==================== */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
  transform: scale(1.1);
}

/* ==================== DIÁLOGOS ==================== */
::v-deep .v-overlay {
  background: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(4px);
}

::v-deep .v-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

::v-deep .v-dialog > .v-card {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3) !important;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-dialog > .v-card > .v-card-title {
  background: rgba(108, 92, 231, 0.1);
  border-bottom: 1px solid rgba(108, 92, 231, 0.2);
  padding: 20px 24px;
  font-size: 1.25rem !important;
  font-weight: 700 !important;
}

.text-h6,
.text-h5 {
  color: #e0e0e0 !important;
  font-weight: 600;
}

/* ==================== CHIPS ==================== */
::v-deep .v-chip {
  background: rgba(108, 92, 231, 0.2) !important;
  border: 1px solid rgba(108, 92, 231, 0.3);
  color: #e0e0e0 !important;
  border-radius: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
}

::v-deep .v-chip:hover {
  background: rgba(108, 92, 231, 0.3) !important;
  border-color: rgba(108, 92, 231, 0.5);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.3);
}

::v-deep .v-chip .v-icon {
  color: #a29bfe !important;
}

/* ==================== TOOLTIPS ==================== */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import HistorialMovimientosArmaDialogComponent from '../../components/armeria/HistorialMovimientosArmaDialogComponent.vue'
import RegistrarMovimientoArmaDialogComponent from '../../components/armeria/RegistrarMovimientoArmaDialogComponent.vue'

export default {
  components: {
    RegistrarMovimientoArmaDialogComponent,
    HistorialMovimientosArmaDialogComponent,
  },

  data() {
    return {
      headers: [
        { text: 'Modelo', value: 'modelo', width: '10%' },

        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],

      selectedMarca: null,
      selectedModelo: null,
      buscaArma: '',
      loading: false,

      historialMovimientosArmaDialog: false,
    }
  },

  computed: {
    ...mapGetters('marcaArma', {
      marcas: 'getMarcaArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArmas: 'getModelosArmas',
    }),

    ...mapGetters('movimientoArma', {
      movimientoArmas: 'getMovimientoArma',
    }),
  },

  methods: {
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('movimientoArma', ['fetchMovimientoArma', 'fetchMovimientoArmaDisponibles']),

    async openEstatusArmaDialog(modelo) {
      this.selectedModelo = modelo
      await this.fetchMovimientoArma(modelo.id)
      await this.fetchMovimientoArmaDisponibles(modelo.id)
      this.historialMovimientosArmaDialog = true
    },
  },
}
</script>
